import {
  ClickEventComponentNames,
  CustomEventNames,
  EventTypes,
  useCRMEventsContext,
} from '@fhs-legacy/frontend/src/state/crm-events';

import { PickerSelectionType } from '../components/guide/types';

export const useComboSelectionEvents = () => {
  const { logRBIEvent } = useCRMEventsContext();

  const logPickerTypeSelection = (selectionType: PickerSelectionType) => {
    logRBIEvent({
      name: CustomEventNames.CLICK_EVENT,
      type: EventTypes.Other,
      attributes: {
        component: ClickEventComponentNames.PICKER_TYPE_SELECTION,
        selectionType,
      },
    });
  };

  return {
    logPickerTypeSelection,
  };
};
